"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowTextEditor = /** @class */ (function (_super) {
    __extends(CardRowTextEditor, _super);
    function CardRowTextEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.GRID_CARD_CSS = { width: '100%', textAlign: 'center', boxShadow: "none", padding: "10px" };
        return _this;
    }
    CardRowTextEditor.prototype.onValueChange = function (e) {
        if (this.props.onValueChanged) {
            this.props.onValueChanged(e.target.value);
        }
    };
    CardRowTextEditor.prototype.getRequiredMark = function () {
        if (this.props.required) {
            return (React.createElement("div", { style: { color: "#FF0000", marginRight: "2px" } }, "*"));
        }
        return (null);
    };
    CardRowTextEditor.prototype.getErrorMessage = function () {
        if (this.props.rules) {
            if (this.props.rules.isError) {
                return (React.createElement("div", { style: { color: "#FF0000", fontSize: "10px", textAlign: "left" } }, this.props.rules.errorMessage));
            }
        }
        return null;
    };
    CardRowTextEditor.prototype.getCSSStyle = function () {
        if (this.props.rules) {
            if (this.props.rules.isError) {
                return { borderColor: "#FF0000", borderStyle: "solid", borderWidth: "1px", borderRadius: "4px" };
            }
        }
        return null;
    };
    CardRowTextEditor.prototype.getRenderObject = function () {
        if (this.props.password) {
            return (React.createElement(antd_1.Input.Password, { addonBefore: React.createElement("div", { style: { width: "200px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", lineHeight: "30px" } },
                    this.getRequiredMark(),
                    React.createElement("div", null, this.props.texts.caption)), placeholder: this.props.texts.placeholder, onChange: this.onValueChange.bind(this), value: this.props.value, disabled: this.props.disabled, style: this.getCSSStyle() }));
        }
        else {
            return (React.createElement(antd_1.Input, { addonBefore: React.createElement("div", { style: { width: "200px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", lineHeight: "30px" } },
                    this.getRequiredMark(),
                    React.createElement("div", null, this.props.texts.caption)), placeholder: this.props.texts.placeholder, onChange: this.onValueChange.bind(this), value: this.props.value, disabled: this.props.disabled, style: this.getCSSStyle() }));
        }
    };
    CardRowTextEditor.prototype.render = function () {
        return (React.createElement(antd_1.Card.Grid, { style: this.GRID_CARD_CSS },
            this.getRenderObject(),
            this.getErrorMessage()));
    };
    return CardRowTextEditor;
}(React.Component));
exports.default = CardRowTextEditor;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/editors/CardRowTextEditor.tsx
// module id = 16
// module chunks = 0